import React from "react";

function PersonalDetails() {
  return null;
}

export default PersonalDetails;
